module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mplan2-fbdea605d82250093e73e4f8218b9140.jpg";